<!--
 * @Description: 成本列支-详情
 * @Date: 2026-04-08 13:59:15
-->

<template>
  <BaseDialog
    width="960px"
    title="成本列支详情"
    :model-value="true"
    :show-close="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
  >
    <BaseTextContent>
      <ul class="table__before__summary">
        <li>所属月份：{{ respData.incomeMonth }}</li>
        <li>开票总金额：{{ formatter.fen2yuan(respData.costAmount, '元') }}</li>
      </ul>
      <BaseTable :data="respData.costItem" :columns="columns" />
    </BaseTextContent>
    <template #footer>
      <BaseButton @click="remove" type="default">关闭</BaseButton>
    </template>
  </BaseDialog>
</template>
<script lang="tsx" setup>
import { onMounted, ref } from 'vue';
import {
  useTableColumn,
  BaseButton,
  BaseDialog,
  BaseTable,
  XrkMessage,
  BaseTextContent
} from 'xrk-components';
import { formatter } from '@/utils';
import { costItemDetail } from '../../data-source/apis';
import { CostItemDetailData } from '../../data-source/types';

import http from '@/utils/http/axios';

const props = defineProps<{
  remove?: () => void;
  id: number;
}>();

const respData = ref<CostItemDetailData>({
  incomeMonth: '',
  costAmount: 0,
  costItem: []
});

const columns = [
  useTableColumn({
    label: '类目',
    prop: 'itemName'
  }),
  useTableColumn({
    label: '比例',
    prop: 'itemValue',
    formatter({ cellValue }) {
      return formatter.fen2yuan(cellValue, '%');
    }
  }),
  useTableColumn({
    label: '占比金额',
    prop: 'amount',
    formatter({ cellValue }) {
      return formatter.fen2yuan(cellValue, '元');
    }
  }),
  useTableColumn({
    label: '上传附件',
    prop: 'handlerCol',
    render: ({ row }) => {
      return (
        row.fileList?.length && (
          <BaseButton
            type="text"
            click={async () => {
              await Promise.all(
                row.fileList.map(async file => {
                  return await http.download(
                    {
                      url: file.url,
                      method: 'GET'
                    },
                    { isShowMessage: false, downloadFileName: file.name }
                  );
                })
              );
              XrkMessage.success('下载成功');
            }}
          >
            下载
          </BaseButton>
        )
      );
    }
  })
];

onMounted(async () => {
  const { data } = await costItemDetail({
    id: props.id
  });
  respData.value = data;
});
</script>
